import axios from "axios";
import UserService from "rc-app/services/UserService";

export const getClientProjects = async (clientId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects?agency_id=${clientId}&page=0&limit=20&lightweight=true`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

export const getFullProjectData = async (
  clientId,
  page = 0,
  limit = 100000,
) => {
  try {
    const listResponse = await fetch(
      `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects?agency_id=${clientId}&page=${page}&limit=${limit}&lightweight=true`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      },
    );
    const listResult = await listResponse.json();
    const lightweightProjects = listResult.projects || [];

    // If no projects, set empty array and return
    if (!lightweightProjects.length) {
      //   setProjects([]);
      return;
    }

    const detailPromises = lightweightProjects.map((project) =>
      fetch(
        `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects/${project?._id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "ngrok-skip-browser-warning": "disabled",
            "Content-Type": "application/json",
          },
        },
      )
        .then((res) => res.json())
        .catch((err) => {
          console.log("testError", err);
        }),
    );

    const allDetailsResults = await Promise.all(detailPromises);
    const finalMergedData = lightweightProjects.map((simpleProject, index) => {
      const detailedProject = allDetailsResults[index]?.project;
      return {
        ...simpleProject,
        ...detailedProject,
        project_id: simpleProject.project_id,
      };
    });

    // setProjects(finalMergedData);
    return finalMergedData;
  } catch (err) {
    console.error("Enrichment failed:", err);
    // setProjects([]); // Set empty on error
  }
};

export const getProjectById = async (projectId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects/${projectId}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

export const editProject = async (jsonData, digitalTwinId) => {
  try {
    console.log("create DigitalTwin", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/projects/${digitalTwinId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

// Sets project display_order (admin-only). Used by both:
//   - AddProject form's edit flow (precise values like 1500.5 to insert
//     between two existing values — DnD can't express fractional inserts)
//   - ProjectsTable's drag-and-drop save, fired N times in parallel
//     (Promise.all). The bulk endpoint /agencies/{id}/projects/order
//     exists per spec but wasn't persisting reliably, so we stick with
//     per-project PUTs which are confirmed working.
export const patchProjectDisplayOrder = async (projectId, displayOrder) => {
  const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/projects/${projectId}`;
  const response = await axios.put(
    API_URL,
    { display_order: displayOrder },
    {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const createProjectByClinetManager = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/projects`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const listAmenities = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/amenities?page=0&limit=1000`,
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching amenities:", error);
  }
};

export const setProjectAmenities = async (projectId, amenityIds) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/projects/${projectId}/amenities`,
      { amenities: amenityIds.map((id) => ({ amenity_id: id, value: true })) },
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error setting project amenities:", error);
  }
};

const toSlug = (name) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const DEFAULT_AMENITIES = [
  { category: "security", items: ["24x7 Security","CCTV Surveillance","Biometric Access","Intercom Facility","Video Door Phone","Gated Community","Fire Safety System","Alarm System","Visitor Management","Smart Security App"] },
  { category: "mobility", items: ["Covered Parking","EV Charging Station","Visitor Parking","Basement Parking","Multi-level Parking","Bicycle Parking","Internal Roads","Shuttle Service","Car Wash Area","Valet Parking"] },
  { category: "outdoor", items: ["Landscaped Garden","Central Park","Walking Track","Jogging Track","Cycling Track","Water Fountain","Zen Garden","Pet Park","Open Lawn","Tree Avenue"] },
  { category: "recreation", items: ["Swimming Pool","Kids Pool","Infinity Pool","Clubhouse","Party Hall","Banquet Hall","Amphitheatre","BBQ Area","Rooftop Lounge","Community Lounge"] },
  { category: "fitness", items: ["Gymnasium","Yoga Room","Meditation Zone","Aerobics Room","Spa","Sauna","Steam Room","Wellness Center","Open Gym","Reflexology Path"] },
  { category: "sports", items: ["Cricket Pitch","Basketball Court","Tennis Court","Badminton Court","Volleyball Court","Football Ground","Skating Rink","Table Tennis","Indoor Games","Golf Area"] },
  { category: "kids", items: ["Kids Play Area","Toddler Zone","Daycare Center","Kids Activity Room","Sand Pit","Adventure Zone","Senior Citizen Area","Family Zone","Slides","Swing Area"] },
  { category: "commercial", items: ["Office Space","High-speed WiFi","Cafe","Retail Shops","ATM","Meeting Rooms","Conference Room","Co-working Space","Shopping Zone","Banking Facility"] },
  { category: "home", items: ["Modular Kitchen","Balcony","Elevator","Power Backup","Air Conditioning","Smart Home","Mobile App Control","Premium Fittings","Main Door Security","Large Windows"] },
  { category: "sustainability", items: ["Solar Panels","Rainwater Harvesting","Recycling System","Waste Management","Energy Efficient Lighting","Water Conservation","Sewage Treatment Plant","Organic Farming","Green Landscaping","Green Building Certified"] },
];

export const seedDefaultAmenities = async () => {
  const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/amenities/create`;
  const headers = {
    Authorization: `Bearer ${UserService.getToken()}`,
    "ngrok-skip-browser-warning": "disabled",
    "Content-Type": "application/json",
  };

  const results = [];
  for (const group of DEFAULT_AMENITIES) {
    for (const name of group.items) {
      try {
        const res = await axios.post(
          API_URL,
          {
            name,
            slug: toSlug(name),
            category: group.category,
            scope: "project",
            value_type: "bool",
            unit: "",
            description: "",
          },
          { headers }
        );
        results.push(res.data);
      } catch (err) {
        console.warn(`Failed to seed amenity "${name}":`, err?.response?.data || err.message);
      }
    }
  }
  return results;
};

export const checkProjectNameExists = async (projectName, agencyId) => {
  try {
    const projects = await getFullProjectData(agencyId);
    if (!projects || projects.length === 0) return null;
    
    const existingProject = projects.find(
      (project) => project.project_name?.toLowerCase() === projectName.toLowerCase()
    );
    return existingProject || null;
  } catch (error) {
    console.error("Error checking project name:", error);
    return null;
  }
};

/**
 * Every project in an agency, with full detail, in ONE request.
 *
 * Exists for the uniqueness checks on the Add Project form. The obvious
 * alternative, getFullProjectData, fetches the lightweight list and then
 * issues a detail request PER PROJECT — fifty projects means fifty-one
 * requests, and the name check was doing that on every pause in typing.
 *
 * `lightweight=false` returns the same information in a single response.
 * The payload is larger; it is fetched once per agency and held, so the
 * field checks after that cost nothing.
 *
 * Slug is why detail is needed at all: ProjectLightweightItem carries
 * project_name but not slug, and slug uniqueness is exactly what a person
 * typing into that field needs to know. If slug is ever added to the
 * lightweight projection, this can go back to the cheap list.
 *
 * @param {string} agencyId
 * @returns {Promise<Array>} projects, or [] on any failure — a check that
 *   cannot run must not block the form.
 */
export const listAgencyProjectsDetailed = async (agencyId) => {
  if (!agencyId) return [];
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects?agency_id=${agencyId}&page=0&limit=100000&lightweight=false`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return Array.isArray(data?.projects) ? data.projects : [];
  } catch (error) {
    console.error("Error listing agency projects:", error);
    return [];
  }
};

/**
 * Every ACTIVE project name on the platform, across all agencies.
 *
 * Project names are globally unique, not unique per agency:
 * Project._validate_unique_project_name queries {project_name, is_active}
 * with no agency filter, so a name taken by any agency is taken for
 * everyone. A check scoped to one agency would say "available" and then be
 * rejected on save.
 *
 * The lightweight projection carries project_name, so this is one small
 * request. `agency_id` is optional on the endpoint; omitting it is what
 * makes it global, and only a user without an agency scope (super admin)
 * gets the full picture — which is exactly who creates projects.
 *
 * @returns {Promise<{exact: Map<string,string>, loose: Map<string,string>}>}
 *   name -> project id, exact and normalised. Empty on failure — a check
 *   that cannot run must not block the form.
 */
export const listAllProjectNames = async () => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/projects?page=0&limit=100000&lightweight=true`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    const out = new Map();
    for (const p of data?.projects || []) {
      const raw = String(p?.project_name || "");
      if (raw.trim()) out.set(raw, String(p?._id || p?.id || ""));
    }
    return out;
  } catch (error) {
    console.error("Error listing project names:", error);
    return new Map();
  }
};
